import { CKTextField } from '@clearkit/react';

export default function MoneyInput({ value, onChange, ...inputProps }) {
  return (
    <CKTextField
      type="number"
      value={value / 100}
      onChange={(e) => {
        const val = Math.round(Number(e.target.value) * 100);
        onChange(val);
      }}
      {...inputProps}
    />
  );
}
